import { cva } from 'cva';
export const radioItemClassNames = [
    '@inline-flex',
    '@items-center',
    '@text-grey-6',
    '@text-b2',
    '[&[data-disabled]]:@text-grey-4',
    '[&[data-disabled]]:@cursor-not-allowed',
];
export const radioVariant = cva({
    base: [
        '@relative',
        '@mr-2',
        '@h-4',
        '@w-4',
        '@bg-grey-2-a',
        '@border',
        '@border-grey-4',
        '@rounded-full',
        'hover:@bg-grey-2',
        'active:@bg-grey-2_3',
        '[&[data-state=checked]]:@bg-grey-0',
        '[&[data-state=checked]]:@border-4',
        '[&[data-state=checked]]:@border-brand1-1',
        '[&[data-disabled]]:@cursor-not-allowed',
        '[&[data-disabled]]:@border-grey-2_3',
        '[&[data-disabled]]:@bg-grey-2',
        '[&[data-disabled][data-state=checked]]:@border',
        '[&[data-disabled][data-state=checked]]:@border-grey-2_3',
        '[&[data-disabled][data-state=checked]]:@bg-grey-2',
        '[&[data-disabled][data-state=checked]]:after:@bg-grey-2_5',
        '[&[data-disabled][data-state=checked]]:after:@border-grey-2_3',
        '[&[data-disabled][data-state=checked]]:after:@absolute',
        '[&[data-disabled][data-state=checked]]:after:@left-1/2',
        '[&[data-disabled][data-state=checked]]:after:@top-1/2',
        '[&[data-disabled][data-state=checked]]:after:@-translate-x-1/2',
        '[&[data-disabled][data-state=checked]]:after:@-translate-y-1/2',
        '[&[data-disabled][data-state=checked]]:after:@w-2',
        '[&[data-disabled][data-state=checked]]:after:@h-2',
        '[&[data-disabled][data-state=checked]]:after:@rounded-full',
    ]
});
